import React, {Component} from "react";
import './UITree.css';

export default class UITree extends Component {

	render() {
		return (
			<div className={'ui-tree'}></div>
		)
	}
}

export class UITreeItem extends Component {
	state = {
		open: false
	}

	toggle = () => {
		this.setState({open: !this.state.open})
	}

	render() {

		return (
			<div className={'ui-tree-item ' + (this.state.open ? 'open' : '')}>
				<div className={'ui-tree-title'} onClick={this.toggle}>
					<div className={'toggle-icon'}>{this.state.open ? '-' : '+'}</div>
					<div className={'title'}>{this.props.title}</div>
				</div>
				{this.state.open ? <div className={'ui-tree-content'}>{this.props.children}</div> : null}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/tree/UITree.jsx